<template>
  <div class="loader">
    <img alt="onera logo" src="@/assets/onera-logo.svg" class="logo" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppInitialLoader'
});
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.5rem;
}

.logo {
  width: 300px;
  height: auto;
  fill: #091fe9 !important;
  animation: pulsate 3s ease-in-out infinite;
  -webkit-animation: pulsate 3s ease-in-out infinite;
  -moz-animation: pulsate 3s ease-in-out infinite;
}

@keyframes pulsate {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.1);
  }

  100% {
    -webkit-transform: scale(1);
  }
}

@-moz-keyframes pulsate {
  0% {
    -moz-transform: scale(1);
  }

  50% {
    -moz-transform: scale(1.1);
  }

  100% {
    -moz-transform: scale(1);
  }
}
</style>
